import script from "./CreateForecastForReceiptModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateForecastForReceiptModal.vue?vue&type=script&lang=ts&setup=true"

import "./CreateForecastForReceiptModal.vue?vue&type=style&index=0&id=59971e80&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59971e80"]])

export default __exports__